var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbareAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 257,
    viewBox: "0 0 356 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1981_606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.181 172.939C305.96 172.939 351.988 134.225 351.988 86.4693C351.988 38.7136 305.96 0 249.181 0C192.402 0 146.374 38.7136 146.374 86.4693C146.374 134.225 192.402 172.939 249.181 172.939Z",
    fill: "#FFF9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.432 142.958C171.432 142.958 187.718 160.225 214.231 167.811C214.231 167.811 204.258 188.653 153.687 186.778C153.687 186.781 191.7 173.048 171.432 142.958Z",
    fill: "#FFF9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.296 33.9738L193.252 115.838C189.876 121.361 193.85 128.451 200.325 128.451H299.828C306.283 128.451 310.26 121.4 306.923 115.876L257.463 34.0093C254.247 28.6909 246.537 28.669 243.296 33.9738Z",
    fill: "#FFD84A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.798 31.8357C244.645 23.9055 256.166 23.9427 260.972 31.8878L310.432 113.756C315.419 122.012 309.476 132.55 299.828 132.55H200.325C190.648 132.55 184.71 121.954 189.754 113.7L189.754 113.7L239.798 31.8364C239.798 31.8362 239.798 31.836 239.798 31.8357ZM253.956 36.131C252.328 33.4396 248.431 33.4328 246.794 36.1114L196.75 117.976C195.043 120.769 197.053 124.351 200.325 124.351H299.828C303.091 124.351 305.101 120.788 303.414 117.996L253.956 36.131Z",
    fill: "#9A5715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.71 68.0433H241.438C241.438 63.2742 245.305 59.407 250.074 59.407C254.843 59.407 258.71 63.2714 258.71 68.0433Z",
    fill: "#7D4E24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.198 94.6108C255.708 97.5515 253.153 99.7953 250.073 99.7953C246.993 99.7953 244.437 97.5543 243.948 94.6108H256.198Z",
    fill: "#7D4E24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.711 67.7019L258.566 69.2734C257.828 73.2936 254.305 76.3382 250.072 76.3382C245.822 76.3382 242.288 73.2663 241.569 69.2214L241.436 67.7019H258.711Z",
    fill: "#7D4E24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.283 94.0971C256.283 94.0615 256.283 94.026 256.283 93.9877C256.283 90.5578 253.501 87.7784 250.074 87.7784C246.646 87.7784 243.864 90.5578 243.864 93.9877C243.864 94.3376 243.894 94.6792 243.949 95.0126H243.864L241.571 68.989C242.29 73.0338 245.824 76.1057 250.074 76.1057C254.307 76.1057 257.83 73.0584 258.568 69.0409L256.283 94.0971Z",
    fill: "#7D4E24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.287 93.7528C256.287 93.7883 256.287 93.8238 256.287 93.8621V93.8676V93.8758L256.205 94.7804H243.956C243.901 94.447 243.871 94.1026 243.871 93.7555C243.871 90.3256 246.653 87.5461 250.08 87.5461C253.508 87.5461 256.287 90.3229 256.287 93.7528Z",
    fill: "#7D4E24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.074 116.554C253.877 116.554 256.961 113.471 256.961 109.667C256.961 105.864 253.877 102.78 250.074 102.78C246.27 102.78 243.187 105.864 243.187 109.667C243.187 113.471 246.27 116.554 250.074 116.554Z",
    fill: "#7D4E24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.463 176.811C144.184 273.22 7.777 272.171 4 176.811C8.27714 80.4019 144.686 81.4514 148.463 176.811Z",
    fill: "#DF6A00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M137.187 184.707C133.834 259.285 28.4552 258.282 25.5801 184.707C28.9335 110.129 134.312 111.132 137.187 184.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8688 179.274C76.8885 209.164 45.5383 211.323 41.6821 182.867C39.6651 152.974 71.0153 150.815 74.8688 179.274Z",
    fill: "url(#paint0_linear_1981_606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.643 173.452C130.644 203.327 98.4793 205.609 94.6012 177.139C92.6007 147.265 124.765 144.98 128.643 173.452Z",
    fill: "url(#paint1_linear_1981_606)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M67.8756 169.178C68.2582 179.164 51.3874 180.132 50.1685 171.094C49.7859 161.108 66.6594 160.14 67.8756 169.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.4153 181.624C54.5984 184.898 48.8646 185.357 48.3891 182.277C48.2059 179.003 53.9425 178.544 54.4153 181.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M121.066 163.42C121.426 173.422 104.115 174.409 102.902 165.385C102.541 155.382 119.852 154.398 121.066 163.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M105.288 174.969C105.466 178.216 99.385 178.711 98.9149 175.658C98.7373 172.411 104.818 171.917 105.288 174.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6908 77.415C60.6908 77.415 44.8641 94.4389 65.5419 106.398L60.6908 77.415Z",
    fill: "#E9611B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7285 77.4094C60.7285 77.4094 81.0456 88.2512 65.5331 106.128L60.7285 77.4094Z",
    fill: "#C7541B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0611 91.7986C29.0611 91.7986 25.5793 110.708 48.0473 111.323L29.0611 91.7986Z",
    fill: "#36ABA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 91.7986C29.0625 91.7986 50.8636 91.7275 48.0486 111.323L29.0625 91.7986Z",
    fill: "#1D888E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1947 81.0059C94.1947 81.0059 103.643 97.7537 82.5986 105.649L94.1947 81.0059Z",
    fill: "#529736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1935 81.0059C94.1935 81.0059 73.5567 88.0351 82.5974 105.649L94.1935 81.0059Z",
    fill: "#72AA35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1981_606",
    x: 0,
    y: 0,
    width: 355.988,
    height: 256.725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1981_606"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1981_606",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1981_606",
    x1: 41.6844,
    y1: 182.876,
    x2: 74.8701,
    y2: 179.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#323231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5035,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7905,
    stopColor: "#20201E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8408,
    stopColor: "#20201E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8939
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1981_606",
    x1: 94.6054,
    y1: 177.14,
    x2: 128.646,
    y2: 173.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#323231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5035,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7905,
    stopColor: "#20201E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8408,
    stopColor: "#20201E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8939
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbareAlert);
export default __webpack_public_path__ + "static/media/abare_alert.36dc80d37e8a94eea893dbf2087c353e.svg";
export { ForwardRef as ReactComponent };